module.exports = __webpack_public_path__ + "static/media/lusitania.ec7b5011.jpg";